'use strict';

(function () {
  angular
    .module('specsguardApp')
    .factory('Project', Project);

  Project.$inject = ['$resource'];

  function Project ($resource) {

    return $resource('/api/project/:id/:firstcontroller/:paramId/:secondcontroller/:secondParamId/:thirdcontroller/:thirdParamId/:fourthcontroller',
      {
        id: '@_id',
        paramId: '@paramId',
        secondParamId: '@secondParamId',
        thirdParamId: '@thirdParamId'
      }, {
        addProject: {
          method: 'POST'
        },
        editProject: {
          method: 'PUT'
        },
        deactivateProject: {
          method: 'DELETE'
        },
        addElement: {
          method: 'POST',
          overrideInterceptor: true,
          params: {
            firstcontroller: 'element'
          }
        },
        editElement: {
          method: 'PUT',
          overrideInterceptor: true,
          params: {
            firstcontroller: 'element'
          }
        },
        editElementParallel: {
          method: 'PUT',
          params: {
            firstcontroller: 'element'
          }
        },
        patchElement: {
          method: 'PATCH',
          overrideInterceptor: true,
          params: {
            firstcontroller: 'element'
          }
        },
        addBasicArea: {
          method: 'POST',
          params: {
            firstcontroller: 'basicarea'
          }
        },
        editBasicArea: {
          method: 'PUT',
          params: {
            firstcontroller: 'basicarea'
          }
        },
        addBuilding: {
          method: 'POST',
          params: {
            firstcontroller: 'building'
          }
        },
        editBuilding: {
          method: 'PUT',
          params: {
            firstcontroller: 'building'
          }
        },
        deactivateBuilding: {
          method: 'PUT',
          params: {
            firstcontroller: 'building',
            secondcontroller: 'delete'
          }
        },
        addCluster: {
          method: 'POST',
          params: {
            firstcontroller: 'building',
            secondcontroller: 'cluster'
          }
        },
        editCluster: {
          method: 'PUT',
          params: {
            firstcontroller: 'building',
            secondcontroller: 'cluster'
          }
        },
        moveCluster: {
          method: 'PUT',
          params: {
            firstcontroller: 'building',
            secondcontroller: 'cluster',
            thirdcontroller: 'move',
          }
        },
        moveArea: {
          method: 'PUT',
          params: {
            firstcontroller: 'building',
            secondcontroller: 'area',
            thirdcontroller: 'move'
          }
        },
        addArea: {
          method: 'POST',
          params: {
            firstcontroller: 'building',
            secondcontroller: 'area'
          }
        },
        editArea: {
          method: 'PUT',
          params: {
            firstcontroller: 'building',
            secondcontroller: 'area'
          }
        },
        importArea: {
          method: 'POST',
          params: {
            firstcontroller: 'building',
            secondcontroller: 'area',
            thirdcontroller: 'import'
          }
        },
        createModule: {
          method: 'POST',
          params: {
            firstcontroller: 'module'
          }
        },
        updateModule: {
          method: 'PATCH',
          params: {
            firstcontroller: 'module'
          }
        },
        updateModuleNoLoader: {
          overrideInterceptor: true,
          method: 'PATCH',
          params: {
            firstcontroller: 'module'
          }
        },
        deactivateModule: {
          method: 'DELETE',
          params: {
            firstcontroller: 'module',
            versionId: 'versionId'
          }
        },
        createSubModule: {
          method: 'POST',
          params: {
            firstcontroller: 'module',
            secondcontroller: 'submodule'
          }
        },
        updateSubModule: {
          method: 'PATCH',
          params: {
            firstcontroller: 'module',
            secondcontroller: 'submodule'
          }
        },
        updateSubModuleNoLoader: {
          overrideInterceptor: true,
          method: 'PATCH',
          params: {
            firstcontroller: 'module',
            secondcontroller: 'submodule'
          }
        },
        deactivateSubModule: {
          method: 'DELETE',
          params: {
            firstcontroller: 'module',
            secondcontroller: 'submodule',
            versionId: 'versionId'
          }
        },
        addElementComment: {
          method: 'POST',
          params: {
            firstcontroller: 'element',
            secondcontroller: 'comment'
          }
        },
        generatePdf: {
          method: 'POST',
          params: {
            firstcontroller: 'generatePdf'
          }
        },
        patchDocument: {
          method: 'PATCH',
          params: {
            firstcontroller: 'document'
          }
        },
        testPdf: {
          method: 'GET',
          params: {
            firstcontroller: 'testPdf'
          }
        },
        getLogs: {
          method: 'GET',
          params: {
            firstcontroller: 'module',
            secondcontroller: 'submodule',
            thirdcontroller: 'element',
            fourthcontroller: 'logs'
          }
        }
      }

    );
  }

})();
